export function resolveStat(team, season, stat) {
  const data = team.seasons[season];

  if (stat === 'tier1Players') {
    const qb = data.tier1_QB?.length || 0;
    const rb = data.tier1_RB?.length || 0;
    const wr = data.tier1_WR?.length || 0;
    const te = data.tier1_TE?.length || 0;

    return {
      sortValue: qb + rb + wr + te,
      displayValue: `${qb} QB, ${rb} RB, ${wr} WR, ${te} TE`
    };
  }

  return {
    sortValue: data[stat],
    displayValue: data[stat]
  };
}

export function generateExpandable(containerId, teams, season, stat, isDescending = true) {
  const statLabels = {
    tradeCount: "Number of Trades",
    pointsFor: "Total Points For",
    pointsPossible: "Total Points Possible",
    pointsAgainst: "Total Points Against",
    avgScore: "Average Score",
    aboveAvgPerc: "% of Games with Above Average Score",
    originalTeamPerc: "% of Original Team Remaining",
    pointsPossiblePerc: "% of Possible Points Scored",
    tier1Players: "Tier 1 Players"
  };

  const container = document.getElementById(containerId);
  container.innerHTML = '';

  const itemId = containerId + '-item';

  const button = createToggleButton(itemId);
  const element = createElement(statLabels[stat], itemId);

  const teamsSorted = [...teams].sort((a, b) => {
    const aStat = resolveStat(a, season, stat).sortValue;
    const bStat = resolveStat(b, season, stat).sortValue;

    const diff = aStat - bStat;

    return isDescending ? -diff : diff;
  });

  teamsSorted.forEach((team, index) => {
    const row = document.createElement('tr');

    const rankCell = document.createElement('td');
    rankCell.textContent = index + 1;
    row.appendChild(rankCell);

    const nameCell = document.createElement('td');
    nameCell.textContent = team.seasons[season].name;
    row.appendChild(nameCell);

    const statCell = document.createElement('td');
    statCell.textContent = resolveStat(team, season, stat).displayValue;
    row.appendChild(statCell);

    element.querySelector('tbody').appendChild(row);
  });

  container.appendChild(button);
  container.appendChild(element);

  button.addEventListener('click', () => toggleElement(button, element));

  return container;
} 

export function createToggleButton(itemId) {
  const button = document.createElement('button');
  button.className = 'expandable-trigger';
  button.setAttribute('aria-expanded', 'false');
  button.setAttribute('aria-controls', itemId);
  button.textContent = 'Show Text Version';
  return button;
}

export function createElement(statLabel, itemId) {
  const element = document.createElement('table');
  element.id = itemId;
  element.classList.add('styled', 'expandable');

  const thead = document.createElement('thead');
  const headerRow = document.createElement('tr');

  const columnNames = ['Rank', 'Team', statLabel];
  columnNames.forEach(column => {
    const th = document.createElement('th');
    if (column === 'Rank') th.classList.add('rank');
    th.textContent = column;
    headerRow.appendChild(th);
  });
  thead.appendChild(headerRow);
  element.appendChild(thead);

  const tbody = document.createElement('tbody');
  element.appendChild(tbody);

  return element;
}

export function toggleElement(button, element) {
  const isExpanded = button.getAttribute('aria-expanded') === 'true';
  if (isExpanded) {
    element.classList.remove('expanded');
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'Show Text Version';
  } else {
    console.log(element);
    element.classList.add('expanded');
    button.setAttribute('aria-expanded', 'true');
    button.textContent = 'Hide Text Version';
  }
}

export function generateHighestScoresList(containerId, wrapperId, highScores) {
  const container = document.getElementById(containerId);
  container.innerHTML = '';

  const itemId = containerId + '-wrapper';
  const table = createElement("Score - Week", itemId);

  const button = createToggleButton(itemId);
  container.prepend(button);

  button.addEventListener('click', () => toggleElement(button, document.getElementById(wrapperId)));

  highScores.forEach((item, index) => {
    const row = document.createElement('tr');

    const rankCell = document.createElement('td');
    rankCell.textContent = index + 1;
    row.appendChild(rankCell);

    const nameCell = document.createElement('td');
    nameCell.textContent = item.team;
    row.appendChild(nameCell);

    const statCell = document.createElement('td');
    statCell.textContent = `${item.score} - Week ${item.week}`;
    row.appendChild(statCell);

    table.querySelector('tbody').appendChild(row);
  });

  container.prepend(button);
  container.appendChild(table);
}

export function generateWeeklyPlacesList(containerId, wrapperId, teams, season) {
  const container = document.getElementById(containerId);
  container.innerHTML = '<div id="'+wrapperId+'" class="expandable"></div>';
  const wrapper = document.getElementById(wrapperId);

  const button = createToggleButton(wrapperId);
  container.prepend(button);

  button.addEventListener('click', () => toggleElement(button, document.getElementById(wrapperId)));
  
  function getPlaceSuffix(place) {
    if (place % 10 === 1 && place % 100 !== 11) return `${place}st`;
    if (place % 10 === 2 && place % 100 !== 12) return `${place}nd`;
    if (place % 10 === 3 && place % 100 !== 13) return `${place}rd`;
    return `${place}th`;
  }

  teams.forEach(team => {
    const teamWrapper = document.createElement('div');
    teamWrapper.classList.add('team-wrapper');

    const teamName = document.createElement('h3');
    teamName.textContent = team.seasons[season].name;
    teamWrapper.appendChild(teamName);

    const ul = document.createElement('ul');
    ul.classList.add('weekly-places-list');

    team.seasons[season].weeklyPlaces.forEach((place, index) => {
      const li = document.createElement('li');
      li.textContent = `Week ${index + 1}: ${getPlaceSuffix(place)}`;
      ul.appendChild(li);
    });

    teamWrapper.appendChild(ul);
    wrapper.appendChild(teamWrapper);
  });
}